module.exports = __webpack_public_path__ + "img/default.07c0a3a5.jpg";